import { render } from "./InfoSign.vue?vue&type=template&id=20137fdd&ts=true"
import script from "./InfoSign.vue?vue&type=script&lang=ts"
export * from "./InfoSign.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__